import KliraSubscription from '../obj/KliraSubscription.js';

let userDetails = localStorage.getItem('user-details')
    ? JSON.parse(localStorage.getItem('user-details'))
    : {id: null, email: null};

// define object structure
window.customer = {
    id: userDetails.id,
    email: userDetails.email,
    first_name: userDetails.first_name,
    last_name: userDetails.last_name,
    customer_id: userDetails.customer_id,
    phone: userDetails.phone,
    subscriptions: null,
    addresses: {
        billing: userDetails.addresses.billing,
        shipping: userDetails.addresses.shipping,
    },

    isLoggedIn: function() {
        return this.id && this.id > 0;
    },
    setDob: async function(day, month, year) {
        // day and month must be 2 digit
        day = String(day).padStart(2, '0')
        month = String(month).padStart(2, '0')

        try {
            const responseJson = await window.utils.request.post(
                `/wp-json/klira/user/update-dob`,
                {
                    dob: `${day}-${month}-${year}`
                }
            )

            let responseObj = JSON.parse(responseJson);

            return responseObj.success;
        } catch (error) {
            console.error('ERROR: ', error);
        }

        return false;
    },
};

// add and populate subscription object
window.customer.subscriptions = {
    objects: [

    ],

    load() {
        let subscriptions = this;

        const hasEndedSubscription =
            userDetails.subscriptions.has_ended_body ||
            userDetails.subscriptions.has_ended_day_script ||
            userDetails.subscriptions.has_ended_night_cream;

        const hasSubscriptions =
            userDetails.subscriptions &&
            userDetails.subscriptions.items.length > 0;

        if (!hasEndedSubscription && !hasSubscriptions) {
            // no ended products and no subscriptions, nothing to load
            return;
        }

        let sub = new KliraSubscription();

        sub.has_night_cream = userDetails.subscriptions.has_night_cream;
        sub.has_body = userDetails.subscriptions.has_body;
        sub.has_day_script = userDetails.subscriptions.has_day_script;
        sub.has_ended_day_script = userDetails.subscriptions.has_ended_day_script;
        sub.has_ended_night_cream = userDetails.subscriptions.has_ended_night_cream;
        sub.has_ended_body = userDetails.subscriptions.has_ended_body;

        userDetails.subscriptions.items.forEach(function(subscriptionItems) {
            sub.items.push(subscriptionItems);
        });

        subscriptions.objects.push(sub);
    },
    hasBody: function() {
        let hasBody = false;

        this.objects.forEach(function(subscription) {
            if (subscription.has_body) {
                hasBody = true;
            }
        });

        return hasBody;
    },
    hasNightCream: function() {
        let hasNightCream = false;

        this.objects.forEach(function(subscription) {
            if (subscription.has_night_cream) {
                hasNightCream = true;
            }
        });

        return hasNightCream;
    },
    hasDayScript: function() {
        let hasDayScript = false;
 
        this.objects.forEach(function(subscription) {
            if (subscription.has_day_script) {
                hasDayScript = true;
            }
        });
 
        return hasDayScript;
    },
    hasEndedBodySubscription: function() {
        let hasEndedBody = false;

        this.objects.forEach(function(subscription) {
            if (subscription.has_ended_body) {
                hasEndedBody = true;
            }
        });

        return hasEndedBody;
    },
     hasEndedDayScriptSubscription: function() {
        let hasDayScript = false;

        this.objects.forEach(function(subscription) {
            if (subscription.has_ended_day_script) {
                hasDayScript = true;
            }
        });

        return hasDayScript;
    },
    hasEndedNightCreamSubscription: function() {
        let hasEndedNightCream = false;

        this.objects.forEach(function(subscription) {
            if (subscription.has_ended_night_cream) {
                hasEndedNightCream = true;
            }
        });

        return hasEndedNightCream;
    },
};

// load subscriptions immediately
window.customer.subscriptions.load();